import { PermissionABACPolicyAssoc } from "../../../model/permission-abac-policy-assoc";
import {getUseQueryResultData} from "../../../util/selector-util";
import {createSelector} from "@reduxjs/toolkit";

export const permissionABACPolicyAssocsSelector = () => createSelector(
  [getUseQueryResultData<PermissionABACPolicyAssoc[]>],
  (data) => {
    return data ?? [];
  }
);

export const permissionABACPolicyAssocSelector = () => createSelector(
  [getUseQueryResultData<PermissionABACPolicyAssoc>],
  (data) => {
    return data
  }
);
